export function ExportEmailCustomerCtrl (
  $uibModalInstance,
  $scope,
  $translate,
  company,
  limited,
  messages,
  workshopAPI,
) {

  $scope.export_type = $translate.instant('CUSTOMER_SPACE.CUSTOMER')
  $scope.company     = company;
  $scope.limited     = limited;

  $scope.email_export = function () {
    const url = $scope.limited ? '/customers/customer_csv_customer_export' : '/customers/customer_csv_admin_export';

    workshopAPI.post(url, {
      email: $scope.email,
      company_id: $scope.company.id
    }, 'customer_data').then(() => {
      messages.show($translate.instant('EXPORT_SPACE.EXPORT_EMAIL_CONFIRM', { email: $scope.email }), 'success');
      $uibModalInstance.close();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  }
}